import { createApp } from 'vue'
import ViewUIPlus from 'view-ui-plus'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles/index.less'
// import './mock'

import http from '@/utils/http'
import util from '@/utils/util';

const app = createApp(App)

// 统一异常处理, 否则出现未捕获的错误页面会卡死
app.config.errorHandler = function (err, vm, info) {
    console.error('Vue error: ', err, info)
}

// 公共方法绑定到全局变量上
app.config.globalProperties.$http = http
app.config.globalProperties.$util = util

app.use(store)
  .use(router)
  .use(ViewUIPlus)
  .mount('#app')
